import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Grid } from '@material-ui/core'

import { GeneralForm } from './components'
import { SetFormState, GetOperators } from '../../../../actions/SettingsActions';


const useStyles = makeStyles(() => ({
    root: {},
}))


const General = (props) => {
    const { className, ...rest } = props

    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector(state => state.session.user);
    const formState = useSelector((state) => state.settingsReducer.formState);
    useEffect(() => {
        let mounted = true;

        dispatch(SetFormState({
            ...formState,
            values: { ...user }
        }))

        if (user && user.id) {
            dispatch(GetOperators(user.id));
        }

        return () => {
            mounted = false
        }
    }, [])

    if (!user) {
        return null
    }

    return (
        <Grid
            {...rest}
            className={clsx(classes.root, className)}
            container
            spacing={3}>
            <Grid item lg={12} md={12} xl={12} xs={12}>
                <GeneralForm role={user.role}/>
            </Grid>
        </Grid>
    )
}

General.propTypes = {
    className: PropTypes.string,
}

export default General
